export enum PaymentMethod {
  CreditCard = 'credit_card',
  ManualBankTransfer = 'bank_transfer',
}
